import React, { useState, useEffect } from 'react';
import DocumentCard from '../components/DocumentCard';
import { grade6Documents } from '../data/dummyData';
import './GradePage.css';

const Grade6Page = () => {
  const [documents, setDocuments] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [selectedYear, setSelectedYear] = useState('All');
  const [selectedSubject, setSelectedSubject] = useState('All');

  useEffect(() => {
    // Load documents
    setDocuments(grade6Documents);
    setFilteredDocs(grade6Documents);
  }, []);

  useEffect(() => {
    // Filter documents based on selections
    let filtered = documents;
    
    if (selectedYear !== 'All') {
      filtered = filtered.filter(doc => doc.year === selectedYear);
    }
    
    if (selectedSubject !== 'All') {
      filtered = filtered.filter(doc => doc.subject === selectedSubject);
    }
    
    setFilteredDocs(filtered);
  }, [selectedYear, selectedSubject, documents]);

  const handleDownload = (docId) => {
    console.log(`Document ${docId} downloaded`);
  };

  // Get unique years and subjects for filters
  const years = ['All', ...new Set(documents.map(doc => doc.year))];
  const subjects = ['All', ...new Set(documents.map(doc => doc.subject))];

  const handleClearFilters = () => {
    setSelectedYear('All');
    setSelectedSubject('All');
  };

  return (
    <div className="grade-page-wrapper">
      <div className="grade-page-container">
        
        {/* Header Section */}
        <header className="grade-page-header">
          <h1 className="grade-page-title">Grade 6 Resources</h1>
          <p className="grade-page-subtitle">
            Access past papers, study materials, and resources for KPSEA preparation
          </p>
        </header>

        {/* Filters Section */}
        <section className="grade-filters-section">
          <div className="filters-header-wrapper">
            <h2 className="filters-section-title">KPSEA Past Papers & Resources</h2>
          </div>
          
          <div className="filters-controls-grid">
            {/* Year Filter */}
            <div className="filter-control-group">
              <label htmlFor="year-filter-select" className="filter-control-label">
                <span className="filter-label-icon"></span>
                Year
              </label>
              <select
                id="year-filter-select"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="filter-control-select"
                aria-label="Filter by year"
              >
                {years.map(year => (
                  <option key={year} value={year}>
                    {year === 'All' ? 'All Years' : year}
                  </option>
                ))}
              </select>
            </div>
            
            {/* Subject Filter */}
            <div className="filter-control-group">
              <label htmlFor="subject-filter-select" className="filter-control-label">
                <span className="filter-label-icon"></span>
                Subject
              </label>
              <select
                id="subject-filter-select"
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
                className="filter-control-select"
                aria-label="Filter by subject"
              >
                {subjects.map(subject => (
                  <option key={subject} value={subject}>
                    {subject === 'All' ? 'All Subjects' : subject}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>
        
        {/* Documents Section */}
        <section className="grade-documents-section">
          {filteredDocs.length > 0 ? (
            <>
              <div className="documents-grid-layout">
                {filteredDocs.map(doc => (
                  <DocumentCard
                    key={doc.id}
                    document={doc}
                    onDownload={handleDownload}
                  />
                ))}
              </div>
            </>
          ) : (
            <div className="no-documents-found">
              <div className="no-results-icon-container">
                <span className="no-results-icon">📭</span>
              </div>
              <h3 className="no-results-title">No documents found</h3>
              <p className="no-results-description">
                No documents match your current filter selections
              </p>
              <button 
                className="clear-filters-action-button"
                onClick={handleClearFilters}
              >
                <span className="action-icon">↺</span>
                Clear all filters
              </button>
            </div>
          )}
        </section>
     
      </div>
    </div>
  );
};

export default Grade6Page;